class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKeys = null;
      if (parsedState.items && parsedState.items.length) {
        this.cartItemKeys = parsedState.items.map(item => item.key);
      } else {
        this.cartItemKey = parsedState.key;
      }
      this.getSectionsToRender().forEach((section => {
        if (section.id == 'cart-notification-product' && this.cartItemKeys && this.cartItemKeys.length) {
          if (document.querySelector('.cart-notification__heading')) {
            document.querySelector('.cart-notification__heading span').innerText = `${this.cartItemKeys.length} ${document.querySelector('.cart-notification__heading').dataset.multipleItemsLabel}`;
          }
          document.getElementById(section.id).classList.add('cart-notification-product--multiple');
          document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], '.shopify-section');
        } else {
          if (section.id == 'cart-notification-product' && document.querySelector('.cart-notification__heading')) {
            document.getElementById(section.id).classList.remove('cart-notification-product--multiple');
            document.querySelector('.cart-notification__heading span').innerText = document.querySelector('.cart-notification__heading').dataset.singleItemLabel;
          }
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
